export const thirdPartyCookies = [
  {
    type: 'Non Essential',
    cookie: '_ga',
    purpose: 'Used to distinguish users in the Google Analytics platform',
    duration: '2 years'
  },
  {
    type: 'Non Essential',
    cookie: '_gat',
    purpose: 'Used to throttle request rate to the Google Analytics platform',
    duration: '10 minutes'
  },
  {
    type: 'Non Essential Session',
    cookie: '_stid,_uset,_unam',
    purpose: 'These cookies allow you to share our content on your favourite social media',
    duration: '2 Years'
  },
  {
    type: 'Non Essential Persistent',
    cookie: 'ai_session',
    purpose:
      'Associated with the Microsoft Application Insights software, which collects statictical usage and telemetry information for apps built on the Azure cloud platform. This is a unique anonymous session identifier cookie',
    duration: '30 mins'
  },
  {
    type: 'Non Essential Persistent',
    cookie: 'ai_user',
    purpose:
      'Associated with the Microsoft Application Insights software, which collects statictical usage and telemetry information for apps built on the Azure cloud platform. This is a unique user identifier cookie enabling counting of the number of users accessing the application over time',
    duration: '1 year'
  },
  {
    type: 'Non Essential Session',
    cookie: 'bc-visit-id_, bcvm_vrid, bc_pv_end_, bcvm_vi, bc-visitor-id, bc-visit-id',
    purpose:
      'These cookies allow us to operate our online chat facility. They allow you to chat directly to an advisor and ask questions /resolve issues',
    duration: 'N/A'
  },
  {
    type: 'Non Essential Session',
    cookie: 'Bing',
    purpose:
      'These cookies track visitors from Bing / Yahoo and whether they have converted or not in a 30 day window',
    duration: '30 Days'
  },
  {
    type: 'Non Essential Session',
    cookie: 'Facebook PPC',
    purpose:
      'These cookies allow us to monitor the success of our Facebook campaigns over a 30 day window',
    duration: '30 Days'
  },
  {
    type: 'Essential Session',
    cookie: 'sc.ASP_NET_SESSIONID',
    purpose: 'Tracks sessions across multiple domains belonging to Zuto',
    duration: '30 minutes'
  }
]

export const firstPartyCookies = [
  {
    type: 'Essential Persistent',
    cookie: 'auth_token',
    purpose: 'Allows us to maintain an authenticated session through our site',
    duration: '1 year'
  },
  {
    type: 'Essential Persistent',
    cookie: 'Device',
    purpose: 'To track a user device through our site',
    duration: '1 year'
  },
  {
    type: 'Essential Persistent',
    cookie: 'IsExperimentalUser',
    purpose: 'Used to allow users to try our new experimental functionality consistently',
    duration: '1 year'
  },
  {
    type: 'Essential Session',
    cookie: 'sc.ASP_NET_SESSIONID',
    purpose: 'Aggregates page views across a unique visit',
    duration: '30 minutes'
  },
  {
    type: 'Essential Persistent',
    cookie: 'sc.OptOut',
    purpose: 'Informs our website of users who have opted out of SessionCam services',
    duration: '1 year'
  },
  {
    type: 'Essential Session',
    cookie: 'sc.Status',
    purpose: 'Checks if session monitoring is enabled for SessionCam services',
    duration: '30 minutes'
  },
  {
    type: 'Essential Persistent',
    cookie: 'sc.UserId',
    purpose: "Aggregates users' sessions over a period of time. Helps us improve user experience",
    duration: '1 year'
  },
  {
    type: 'Essential Persistent',
    cookie: 'Session',
    purpose: 'To track a user session through our site',
    duration: '30 minutes'
  },
  {
    type: 'Essential Session',
    cookie: 'SessionCamTestCookie',
    purpose:
      'Checks if cookies are allowed to read/write. The cookie is deleted immediately if read/write is not permitted',
    duration: 'N/A'
  },
  {
    type: 'Essential Persistent',
    cookie: 'user',
    purpose: 'To track a user session through our site',
    duration: '30 minutes'
  },
  {
    type: 'Essential Persistent',
    cookie: 'zuto_cookie_consent',
    purpose: 'Allows us to remember whether you have accepted the cookie policy or not',
    duration: '6 months'
  },
  {
    type: 'Essential Session',
    cookie: 'zuto_source, zuto_medium, zuto_campaign, zuto_content, zuto_keyword, zuto_gclid',
    purpose: 'Allows us track sessions for marketing attribution',
    duration: 'N/A'
  }
]
